/*--------------------------------------------------------------
# Custom scripts for Testimonial block
--------------------------------------------------------------*/

var testiSlider = jQuery('.testi-slider');

if (testiSlider.length > 0) {
    // set slides to same height - keeping code here incase adaptive height is removed
    // testiSlider.on('setPosition', function () {
    //     jQuery(this).find('.testi-slider__item').height('auto');
    //     var slickTrack = jQuery(this).find('.slick-track');
    //     var slickTrackHeight = jQuery(slickTrack).height();
    //     jQuery(this).find('.testi-slider__item').css('height', slickTrackHeight + 'px');
    // });

    // set slider options
    var testiSliderOptions = {
        adaptiveHeight: true,
        arrows: true,
        dots: true,
        infinite: true,
        nextArrow: '<button class="slick-arrow slick-next"><span class="visually-hidden">Next</span><span class="ico icon-arrow-right-simplified" aria-hidden="true"></span></button>',
        prevArrow: '<button class="slick-arrow slick-prev"><span class="visually-hidden">Previous</span><span class="ico icon-arrow-left-simplified" aria-hidden="true"></span></button>',
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            }
        ]
    };

    // make adaptive height when more than one slide
    // my slick slider as constant object
    const myTestiSlider = jQuery('.testi-slider').on('init', function(slick) {

        // on init run our multi slide adaptive height function
        multiSlideAdaptiveHeight(this);
  
    }).on('beforeChange', function(slick, currentSlide, nextSlide) {
  
        // on beforeChange run our multi slide adaptive height function
        multiSlideAdaptiveHeight(this);
  
    }).slick(testiSliderOptions);
  
  
    // our multi slide adaptive height function passing slider object
    function multiSlideAdaptiveHeight(slider) {
  
        // set our vars
        let activeSlides = [];
        let tallestSlide = 0;
  
        // very short delay in order for us get the correct active slides
        setTimeout(function() {
  
            // loop through each active slide for our current slider
            jQuery('.slick-track .slick-active', slider).each(function(item) {
        
                // add current active slide height to our active slides array
                activeSlides[item] = jQuery(this).outerHeight();
        
            });
  
            // for each of the active slides heights
            activeSlides.forEach(function(item) {
        
                // if current active slide height is greater than tallest slide height
                if (item > tallestSlide) {
        
                // override tallest slide height to current active slide height
                tallestSlide = item;
        
                }
  
            });
  
            // set the current slider slick list height to current active tallest slide height
            jQuery('.slick-list', slider).height(tallestSlide);
    
        }, 10);
    }
  
  
    // when window is resized
    jQuery(window).on('resize', function() {
  
        // run our multi slide adaptive height function incase current slider active slides change height responsively
        multiSlideAdaptiveHeight(myTestiSlider);
  
    });
}

// DEV NOTE - in spec only 1 testimonial with image slide is aloud but keeping this script here incase it needs turning into a carousel if they have option to add more than one
// var testiWithImageSlider = jQuery('.testi-with-image-slider');

// if (testiWithImageSlider.length > 0) {
    // set slides to same height
    // testiWithImageSlider.on('setPosition', function () {
    //     jQuery(this).find('.testi-with-image-slider__item').height('auto');
    //     var slickTrack = jQuery(this).find('.slick-track');
    //     var slickTrackHeight = jQuery(slickTrack).height();
    //     jQuery(this).find('.testi-with-image-slider__item').css('height', slickTrackHeight + 'px');
    // });

    // initiate slider 
    // testiWithImageSlider.slick({
    //     adaptiveHeight: true,
    //     arrows: true,
    //     dots: true,
    //     infinite: true,
    //     nextArrow: '<button class="slick-arrow slick-next"><span class="visually-hidden">Next</span><span class="ico icon-arrow-right-simplified" aria-hidden="true"></span></button>',
    //     prevArrow: '<button class="slick-arrow slick-prev"><span class="visually-hidden">Previous</span><span class="ico icon-arrow-left-simplified" aria-hidden="true"></span></button>',
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     mobileFirst: true
    // });
// }
